<template>
    <div class="Tabs">
        <div class="Container">
            <QList
                class="TabsList"
                :class="{ horizontal }"
            >
                <QItem
                    v-for="(tab, index) in tabs"
                    :key="`tab-${index}`"
                    v-ripple
                    clickable
                    :disable="tab.disabled"
                    activeClass="active"
                    :active="value === tab.id"
                    class="Tab"
                    :class="[type, { disabled: tab.disabled, horizontal }]"
                    tag="button"
                    type="button"
                    @click="handleClickItem(tab)"
                >
                    <QItemSection
                        v-if="tab.icon"
                        avatar
                    >
                        <QIcon
                            :name="tab.icon"
                            size="24px"
                        />
                    </QItemSection>

                    <QItemSection>
                        <QItemLabel class="TabLabel">
                            {{ tab.label }}
                        </QItemLabel>
                    </QItemSection>

                    <QItemSection
                        v-if="tab.badge"
                        side
                    >
                        <QBadge
                            class="Badge"
                            :color="tab.badge.color"
                            :label="tab.badge.label"
                        />
                    </QItemSection>
                </QItem>
            </QList>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'Tabs2Component',
    props: {
        value: VueTypes.string,
        tabs: VueTypes.arrayOf([
            VueTypes.shape({
                id: VueTypes.string,
                icon: VueTypes.string,
                label: VueTypes.string,
                disabled: VueTypes.bool,
            }).loose,
        ]).isRequired,
        type: VueTypes.oneOf(['', 'secondary']).def(''),
        horizontal: VueTypes.bool.def(false),
    },
    emits: ['onClick'],
    methods: {
        handleClickItem(tab) {
            if (!tab.disabled) {
                this.$emit('onClick', tab.id)
            }
        },
    },
}
</script>

<style scoped lang="scss">
.Tabs {
    width: 100%;
    transition: $transition;
}

.Container {
    padding: 15px 0;
}

.Badge {
  margin-left: 10px;
}

.TabsList {
    width: 100%;
    transition: $transition;

    &.horizontal {
        display: flex;
        height: 35px;
        padding: 0;
    }
}

.Tab {
    color: $primary;
    width: 100%;
    min-height: 40px;
    height: 100%;
    padding: 20px 22px;
    background: transparent;
    border: 0;
    outline: none;
    font-size: 10px;
    font-weight: $font-weight-semibold;
    opacity: 0.5;
    transition: $transition;
    cursor: pointer;

    @media screen and (min-width: $md) {
        font-size: 12px;
    }

    &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 3px;
        height: 0px;
        background: $primary;
        border-radius: $border-radius;
        transition: all $transition;
    }

    &:hover,
    &:active,
    &:focus,
    &.active {
        opacity: 1;
        &:after {
            height: 100%;
        }
    }

    &.disabled {
        cursor: not-allowed;
    }

    &:hover {
        background: rgba($primary, 0.1);
    }

    .q-icon {
        color: $primary;
    }

    .TabLabel {
        display: none;
        text-align: left;

        @media screen and (min-width: $md) {
            display: inline-block;
        }
    }

    &.secondary {
        color: $white;

        .q-icon {
            color: $white;
        }
    }

    &.horizontal {
        justify-content: start;

        &:after {
            top: initial;
            bottom: 0;
            width: 0px;
            height: 3px;
        }

        &:hover,
        &:active,
        &:focus,
        &.active {
            &:after {
                width: 100%;
            }
        }
    }
}
</style>
